import React, { useState, useEffect, ChangeEvent } from 'react';
import { useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';
import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useLanguage, useAuth, usePortalInfos } from 'hooks';
import { showModal, hideModal } from 'state/actions';
import { MODAL, ENG, EN, FR, ADD_NEW_FAVORITE_LISTING_STEP } from 'config/constants';
import { HvModal, HvButton } from 'components';
import {
  AddNewFavoriteListingOptions,
  NewListingSearch,
  ConfirmNewFavoriteListing,
  DemoListings,
} from './ModalStepper/index';

const useStyles = makeStyles({
  content: {
    padding: 50,
  },
  row: {
    justifyContent: 'space-between',
    marginBottom: 10,
  },
});

function AddNewFavoriteListingModal() {
  const intl = useIntl();
  const styles = useStyles();
  const dispatch = useDispatch();
  const language = useLanguage();
  const isEn = language === ENG;
  const initialStep = 0;
  const [activeStep, setActiveStep] = useState(initialStep);

  const [selectedListings, setSelectedListings] = useState([]);
  const { token } = useAuth();
  const { favorite_listings } = usePortalInfos(token, null, isEn ? EN : FR);

  useEffect(() => {}, [selectedListings, activeStep, setActiveStep]);

  const stepContent = () => {
    switch (activeStep) {
      case ADD_NEW_FAVORITE_LISTING_STEP.OPTIONS:
        return (
          <AddNewFavoriteListingOptions
            key={0}
            setActiveStep={setActiveStep}
            activeStep={activeStep}
          />
        );
      case ADD_NEW_FAVORITE_LISTING_STEP.DEMO_LISTINGS:
        return (
          <DemoListings
            key={1}
            setActiveStep={setActiveStep}
            selectedListings={selectedListings}
            setSelectedListings={setSelectedListings}
            activeStep={activeStep}
            favorite_listings={favorite_listings}
          />
        );
      case ADD_NEW_FAVORITE_LISTING_STEP.SEARCH_LISTING:
        return (
          <NewListingSearch
            key={2}
            setActiveStep={setActiveStep}
            selectedListings={selectedListings}
            setSelectedListings={setSelectedListings}
            activeStep={activeStep}
            favorite_listings={favorite_listings}
          />
        );
      case ADD_NEW_FAVORITE_LISTING_STEP.CONFIRM:
        return (
          <ConfirmNewFavoriteListing
            key={3}
            setActiveStep={setActiveStep}
            selectedListings={selectedListings}
            setSelectedListings={setSelectedListings}
            activeStep={activeStep}
            favorite_listings={favorite_listings}
          />
        );
      default:
        return (
          <AddNewFavoriteListingOptions
            key={0}
            setActiveStep={setActiveStep}
            activeStep={activeStep}
          />
        );
    }
  };
  return <Box className={styles.content}>{stepContent()}</Box>;
}
export default AddNewFavoriteListingModal;
